'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _fastDeepEqual = require('fast-deep-equal');

var _fastDeepEqual2 = _interopRequireDefault(_fastDeepEqual);

var _metrixCommon = require('metrix-common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WorkflowDocumentUpload = function (_React$Component) {
    _inherits(WorkflowDocumentUpload, _React$Component);

    function WorkflowDocumentUpload() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, WorkflowDocumentUpload);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WorkflowDocumentUpload.__proto__ || Object.getPrototypeOf(WorkflowDocumentUpload)).call.apply(_ref, [this].concat(args))), _this), _this.getDocuments = function () {
            var documents = [];

            if (_this.props.document && _this.props.document.documents && _this.props.document.documents.length > 0) {
                _this.props.document.documents.forEach(function (document) {
                    var option = { code: document.guid, value: 'document' };

                    var documentName = document.displayName;

                    option.elements = [];

                    option.elements.push({ type: 'text', value: documentName });

                    documents.push(option);
                });
            }

            return documents;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WorkflowDocumentUpload, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.document) {
                this.props.document.doReduceDocumentQueryElement({ code: 'ownerGuid', value: this.props.entity });
                this.props.document.doReduceDocumentQueryElement({ code: 'partyGuid', value: this.props.session.partyGuid });
                this.props.document.doReduceDocumentQueryElement({ code: 'type', value: 'policyDocument' });
                this.props.document.doQueryDocuments();
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return !(0, _fastDeepEqual2.default)(this.props, nextProps);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var documentCount = 0;

            if (this.props.document && this.props.document.documents && this.props.document.documents.length > 0) {
                documentCount = this.props.document.documents.length;
            }

            this.props.doSetReturn({ componentCode: this.props.component.code, code: 'count', value: documentCount });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(_metrixCommon.SummaryGroup, {
                    allowDelete: true,
                    deleteEvent: function deleteEvent(entity) {
                        _this2.props.document.doDeleteDocument(entity);
                    },
                    componentCode: this.props.component.code,
                    items: this.getDocuments(),
                    icon: 'documents'
                }),
                _react2.default.createElement(
                    _metrixCommon.Container,
                    { inline: true },
                    _react2.default.createElement(_metrixCommon.UploadButton, { text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Upload' }), changeEvent: function changeEvent(e) {
                            _this2.props.document.doCreateDocument({ entity: _this2.props.entity, type: 'policyDocument', file: e.target.files[0] });
                        }
                    })
                )
            );
        }
    }]);

    return WorkflowDocumentUpload;
}(_react2.default.Component);

exports.default = WorkflowDocumentUpload;